import React, { useEffect, useState } from "react";

/* Common */
import { Button } from "../../common";

/* Utilities */
import { trans, getCloudimageUrl, checkVehicleExists } from '~/utilities';

export default function HeroOverlay({ vehicleExistsUrl }) {
    const [overlayItems, setOverlayItems] = useState([]);

    const toAbsoluteUrl = (url) =>
        /^https?:\/\//i.test(url) ? url : `${window.location.origin}${url}`;

    // Keep the item when no identifier is available to verify (legacy storage).
    const stillExists = async (value, paramName = 'uuid') =>
        !value ? true : await checkVehicleExists(value, vehicleExistsUrl, paramName);

    useEffect(() => {
        const buildOverlayItems = async () => {
            const storedFlow = localStorage.getItem('unfinished-flow');
            const lastVehicle = localStorage.getItem('last-visited-vehicle');
            const newOverlayItems = [];

            if (storedFlow) {
                const flowObject = JSON.parse(storedFlow);

                if (await stillExists(flowObject.vehicleId, 'id')) {
                    const urlWithParam = new URL(flowObject.url);
                    urlWithParam.searchParams.set('openLastFlow', 'true');

                    newOverlayItems.push({
                        image: toAbsoluteUrl(flowObject.image),
                        brand: flowObject.brand,
                        model: flowObject.model,
                        type: flowObject.type,
                        cta: {
                            url: urlWithParam.toString(),
                            title: trans(`app.content_block.hero.overlay_flow_button`, { 'flow': flowObject.flowTitle})
                        }
                    });
                } else {
                    localStorage.removeItem('unfinished-flow');
                }
            }

            if (lastVehicle) {
                const vehicleObject = JSON.parse(lastVehicle);

                if (await stillExists(vehicleObject.uuid)) {
                    newOverlayItems.push({
                        image: toAbsoluteUrl(vehicleObject.image),
                        brand: vehicleObject.brand,
                        model: vehicleObject.model,
                        type: vehicleObject.type,
                        cta: {
                            url: vehicleObject.url,
                            title: trans(`app.content_block.hero.overlay_detail_button`)
                        }
                    });
                } else {
                    localStorage.removeItem('last-visited-vehicle');
                }
            }

            if (newOverlayItems.length > 0) {
                const heroElement = document.querySelector('.hero');
                if (heroElement) heroElement.classList.add('hero--has-overlay');
            }

            setOverlayItems(newOverlayItems);
        };

        buildOverlayItems();
    }, []);

    return (
        <div className="container">
            <div className="row justify-content-end">
                <div className="col-12 col-lg-auto">
                    {(overlayItems && overlayItems.length > 0) ? (
                        <div className="hero__flow-overlay card bg-contrast shadow d-flex flex-column p-4 p-lg-6">
                            <h6 className="text--18 text--lg-20 mb-4">{trans(`app.content_block.hero.overlay_title`)}</h6>
                            <div className="d-flex flex-column flex-lg-row gap-6">
                                {overlayItems.map((overlayItem, index) => {
                                    return (
                                        <div key={index} className="hero__flow-overlay__item d-flex gap-2 gap-xl-4">
                                            <img className="hero__flow-overlay__image" src={getCloudimageUrl(overlayItem.image, {w: 260, func: 'crop'})} alt={`${overlayItem.brand} ${overlayItem.model}`}/>
                                            <div className="d-flex flex-column align-items-baseline">
                                                <p className="font-weight-bold text--16 line-height-1 hero__flow-overlay__brand text-base">{overlayItem.brand} {overlayItem.model}</p>
                                                <p className="mb-2 text--14 text-muted--60 line-height-1">{overlayItem.type}</p>
                                                <Button
                                                    className="btn-sm mt-auto"
                                                    theme="outline-quaternary"
                                                    title={overlayItem.cta.title}
                                                    showIcon={false}
                                                    href={overlayItem.cta.url}
                                                />
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    ) : null}
                </div>
            </div>
        </div>
    );
}
